module.exports = __webpack_public_path__ + "static/media/customisable_features.28040dca.svg";